<template>
	<van-popup v-model:show="show" position="bottom" round>
		<div class="account-list">
			<div class="account-info">
				<img src="@/assets/images/center/avatar.png" alt="" class="avatar" />
				<div style="flex: 1">
					<div class="username">用户xju000001</div>
					<div class="account">账号：1234563112</div>
				</div>
				<img :src="selectBoxImg" alt="" class="select-box" />
			</div>
			<div class="account-info">
				<img src="@/assets/images/center/avatar.png" alt="" class="avatar" />
				<div style="flex: 1">
					<div class="username">用户xju000001</div>
					<div class="account">账号：1234563112</div>
				</div>
				<img :src="selectBoxImg" alt="" class="select-box" />
			</div>
			<div class="account-info">
				<img src="@/assets/images/center/avatar.png" alt="" class="avatar" />
				<div style="flex: 1">
					<div class="username">
						<div>用户xju000001</div>
						<img class="select" src="@/assets/images/center/select.png" alt="" />
					</div>
					<div class="account">账号：1234563112</div>
				</div>
				<img :src="selectedBoxImg" alt="" class="select-box" />
			</div>
			<div class="account-info">
				<img src="@/assets/images/center/add_avatar.png" alt="" class="avatar" />
				<div style="flex: 1">
					<div class="username">添加或注册新账号</div>
				</div>
			</div>
		</div>
	</van-popup>
</template>

<script setup lang="ts">
import selectBoxImg from '@/assets/images/center/select_box.png'
import selectedBoxImg from '@/assets/images/center/selected_box.png'
const show = ref<boolean>(false)

defineExpose({ show })
</script>

<style scoped lang="scss">
.account-list {
	padding: 15px 20px;
	.account-info {
		margin-top: 20px;
		display: flex;
		align-items: center;
		.avatar {
			width: 50px;
			margin-right: 15px;
		}
		.username {
			display: flex;
			align-items: center;
			font-size: 16px;
			font-weight: 500;
			line-height: 23px;
			color: #090d10;
			.select {
				margin-left: 10px;
				width: 22px;
			}
		}
		.account {
			margin-top: 5px;
			font-size: 14px;
			color: #7d7e80;
			line-height: 16px;
		}
		.select-box {
			width: 22px;
		}
	}
}
</style>
